import * as yup from 'yup';

export const ScheduleChecklistValidationSchema = yup.object({
  phaseId: yup.string().nullable().required('Please select phase item'),
  phaseItemId: yup.string().nullable().required('Please select schedule item'),
  items: yup.array().of(
    yup.object().shape({
      id: yup.number().required('Field is required'),
      name: yup.string().required('Field is required').max(250, 'Must be 250 characters or less'),
    })
  ),
});

export const EditScheduleChecklistValidationSchema = yup.object({
  phaseId: yup.string().nullable().required('Please select phase item'),
  phaseItemId: yup.string().nullable().required('Please select schedule item'),
  items: yup.array().of(
    yup.object().shape({
      id: yup.number().required('Field is required'),
      name: yup.string().required('Field is required').max(250, 'Must be 250 characters or less'),
    })
  ),
});

export const ApplyChecklistTemplateValidationSchema = yup.object({
  template: yup.string().nullable().required('Please select template item'),
});
